import { render, staticRenderFns } from "./secondCard.vue?vue&type=template&id=18f846cc&scoped=true&"
import script from "./secondCard.vue?vue&type=script&lang=js&"
export * from "./secondCard.vue?vue&type=script&lang=js&"
import style0 from "./secondCard.vue?vue&type=style&index=0&id=18f846cc&prod&scoped=true&lang=css&"
import style1 from "./secondCard.vue?vue&type=style&index=1&id=18f846cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f846cc",
  null
  
)

export default component.exports